import { ActionType, action as makeAction } from 'typesafe-actions'
import { Action } from '../store'

// types
export const FLAG_LOADING = 'FLAG_LOADING'
export const FLAG_BLOCK_LOADING = 'FLAG_BLOCK_LOADING'

export interface LoadingState {
  readonly isLoading: boolean
  readonly isBlockingLoading: boolean
}

// actions
export const flagLoading = (isLoading: boolean) =>
  makeAction(FLAG_LOADING, { isLoading })

export const flagBlockingLoading = (isBlockingLoading: boolean) =>
  makeAction(FLAG_BLOCK_LOADING, { isBlockingLoading })

export const actions = {
  flagLoading,
  flagBlockingLoading,
}

export type LoadingAction = ActionType<typeof actions>

const isFetchStart = (str: string) => {
  return str.match(/FETCH_START\b/)
}
const isFetchEnd = (str: string) => {
  return str.match(/FETCH_OK\b/) || str.match(/FETCH_ERROR\b/)
}

// reducer
export const loadingReducer = (
  state: LoadingState = {
    isLoading: false,
    isBlockingLoading: false,
  },
  action: Action,
) => {
  if (action.type === FLAG_LOADING) {
    return { ...state, isLoading: action.payload.isLoading }
  }
  if (action.type === FLAG_BLOCK_LOADING) {
    return { ...state, isBlockingLoading: action.payload.isBlockingLoading }
  }
  // listen to all action ends with FETCH_START, FETCH_ERROR, FETCH_OK
  if (isFetchStart(action.type)) {
    return { ...state, isLoading: true, isBlockingLoading: false }
  }
  if (isFetchEnd(action.type)) {
    return { ...state, isLoading: false, isBlockingLoading: false }
  }

  return state
}
